import urlHelper from '../Helpers/urlHelper';

export default class PaymentAppliedItem {
  constructor(item) {
    if (item) {
      this.ClientPaymentId = item.clientPaymentId;
      this.PaymentDate = item.paymentDate;
      this.NumLinesPaid = item.numLinesPaid;
      this.Paid = item.paid;
      this.CheckNumber = item.checkNumber;
      this.ClientInvoiceId = item.clientInvoiceId;
      this.CurrencySymbol = item.currencySymbol;
      this.CurrencyCode = item.currencyCode;
      return;
    }
    this.ClientPaymentId = '';
    this.PaymentDate = '';
    this.NumLinesPaid = '';
    this.Paid = '';
    this.CheckNumber = '';
    this.ClientInvoiceId = '';
    this.CurrencySymbol = '';
    this.CurrencyCode = '';
  }

  static DateFields = ['PaymentDate'];
  static MoneyFields = ['Paid'];

  static Currency() {
    return 'CurrencyCode';
  }
  static MoneyFieldsSecondary = ['Paid'];
  static CurrencySecondary() {
    return 'CurrencyCode';
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Client Payment',
        orderById: 'ClientPaymentId',
        data: PaymentAppliedItem.GetDetailCellContent,
        minWidth: 20
      },
      {
        label: 'Paid On',
        orderById: 'PaymentDate',
        data: 'PaymentDate',
        minWidth: 50
      },
      {
        label: 'Items Paid',
        orderById: 'NumLinesPaid',
        data: 'NumLinesPaid',
        minWidth: 20
      },
      { label: 'Paid', orderById: 'Paid', data: 'Paid', minWidth: 20 },
      { label: 'Check Number', orderById: 'CheckNumber', data: 'CheckNumber', minWidth: 20 },
      { label: 'Client Invoice', orderById: 'ClientInvoiceId', data: 'ClientInvoiceId', minWidth: 20 }
    ];
  }

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.ClientPaymentId,
      '',
      '',
      'clientpaymentdetails',
      `id=${item.ClientPaymentId}`,
      'Open up in a new tab'
    );
  }
}
